export function getSeriesReservationTimeHours({ userId: _ }: { userId: number }): number {
  return 48
}

export function getSeriesFriendReservationTimeHours({ userId: _ }: { userId: number }): number {
  return 48
}
